import React from "react";
import { Link } from "react-router-dom";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";

export default function GalleryWalls() {
  return (
    <div className="Gallery-Wraps-2 retouching Canvases">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          data-background="assets/img/breadcrumb/Canvases.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/Canvases.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Gallery Walls <br />
                  </h3>
                  <p className="w-100 b-heading">
                      We have Created 10 different Gallery Walls. These Artistic
                      displays enhance your Life with your wonderful memories.
                      Gallery Walls are 20% less expensive if those canvases
                      were purchased individually.
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        {/* second content section start*/}
        <section className="parent">
          <section
            className=" pb-100 Partener photographs"
            data-background="assets/img/breadcrumb/routing.png"
            style={{ backgroundImage: 'url("assets/img/breadcrumb/routing.png")', backgroundSize: "cover" }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center pt-30">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                    {/* <h4 className="text-left second">
                      Create Your Gallery Wall   With Multiple Canvas
                    </h4> */}
                    {/* <p className="w-100">
                      We have Created 10 different Gallery Walls. These Artistic
                      displays enhance your Life with your wonderful memories.
                      Gallery Walls are 20% less expensive if those canvases
                      were purchased individually.
                    </p> */}
                  </div>
                </div>
                <div
                  id="carouselExampleControls"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src="assets/img/blog/slider-one.png"
                        className="d-block m-auto"
                        alt="..."
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="assets/img/blog/slider-one.png"
                        className="d-block m-auto "
                        alt="..."
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="assets/img/blog/slider-one.png"
                        className="d-block m-auto"
                        alt="..."
                      />
                    </div>
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
                {/* <div className="col-xl-12 col-lg-12 col-md-12 text-center pt-50">
                  <h4 className="text-left second">Gallery Wall #01</h4>
                  <p className="w-50">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Integer non ante eget nulla efficitur elementum. Donec
                    aliquam dignissim eros non pharetra.
                  </p>
                </div> */}
                <div className="text-center mt-60 button-uper"> 
                  <Link to={"/create-custom-print"} className="large head banner">
                    Create GALLERY WALL
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* second content section end */}
      
        <UpperFooterSlider />
      </main>
    </div>
  );
}
